import { getUsers, setUserIndex } from '@back-office/core';
import { GcpBox, GcpFallback, GcpPublicWrapper } from '@back-office/ui';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginStep } from '../forms';
import useInject from '../hooks/useInject';
import EnterOTP from './login/EnterOTP';
import ForgotPassword from './login/ForgotPassword';
import LoginComponent from './login/LoginComponent';
import SelectMerchant from './login/SelectMerchant';

const Step: FC<{
  step: LoginStep;
}> = observer((props) => {
  const { step } = props;
  const { auth, setLoginStep, forgotPwdEmail } = useInject((root) => root);
  const { t } = useTranslation();

  const handleOnClick = (): void => {
    setLoginStep(LoginStep.Login);
  };

  const setAuth = (userIndex: number): void => {
    const users = getUsers() || [];
    setUserIndex(userIndex);
    auth.setCurrentUser(users[userIndex]);
    auth.setAuth(true);
    setLoginStep(LoginStep.Login);
  };

  switch (step) {
    case LoginStep.Login:
      return <LoginComponent />;
    case LoginStep.EnterOTP:
      return <EnterOTP setAuth={setAuth} />;
    case LoginStep.SelectMerchant:
      return <SelectMerchant setAuth={setAuth} />;
    case LoginStep.ForgotPassword:
      return <ForgotPassword />;
    case LoginStep.CheckEmail:
      return (
        <GcpFallback
          btn="login_form.sign_in"
          handleOnClick={handleOnClick}
          message={t('forgot.reset_desc', { email: forgotPwdEmail })}
          title={t('forgot.check')}
        />
      );
    default:
      return null;
  }
});

const Login: FC = observer(() => {
  const { loginStep } = useInject((root) => root);

  return loginStep === LoginStep.CheckEmail ? (
    <Step step={loginStep} />
  ) : (
    <GcpPublicWrapper>
      <GcpBox isFullWidth mt={2}>
        <Step step={loginStep as LoginStep} />
      </GcpBox>
    </GcpPublicWrapper>
  );
});

export default Login;
